export function webLink(path = '') {
	return `https://trackdesk.com/${path}`
}

export function environmentLink(environmentDomain: string, path: string, customToken: string) {
	return `//${import.meta.env.VITE_ENVIRONMENT_URL || environmentDomain}/${path}?signInToken=${customToken}`
}
